import { render, staticRenderFns } from "./myset.vue?vue&type=template&id=2088f086&scoped=true"
import script from "./myset.vue?vue&type=script&lang=js"
export * from "./myset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2088f086",
  null
  
)

export default component.exports